// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3eEmP","gfeWrapper":"CalendarEvent_gfeWrapper__10-I_"};